import React from 'react'
import { LucideIcon } from 'lucide-react'
import styles from './InfoItem.module.scss'

interface InfoItemProps {
  icon: LucideIcon
  title: string
  content: string | React.ReactNode
  className?: string
}

const InfoItem: React.FC<InfoItemProps> = ({ icon: Icon, title, content, className = '' }) => {
  return (
    <div className={`${styles.infoItem} ${className}`}>
      <div className={styles.iconWrapper}>
        <Icon className={styles.icon} size={20} />
      </div>
      <div className={styles.content}>
        <p className={styles.title}>{title}</p>
        <div className={styles.value}>{content}</div>
      </div>
    </div>
  )
}

export default InfoItem
